/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Vertical_Text_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Switch to horizontal text" |
*
* @param {Input_Position_Vertical_Text_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_vertical_text_aria_label = /** @type {((inputs?: Input_Position_Vertical_Text_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Vertical_Text_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer vers le texte horizontal")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf horizontalen Text umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passa al testo orizzontale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключиться на горизонтальный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar a texto horizontal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换到横屏模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("横書きテキストに切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्षैतिज पाठ पर स्विच करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar para texto horizontal")
	return /** @type {LocalizedString} */ ("Switch to horizontal text")
});